import {
  AccountCircleOutlined,
  AddModeratorOutlined,
  Dashboard,
  FolderSharedOutlined,
  NotificationsActiveOutlined,
  PaidOutlined,
  PeopleAltOutlined,
} from "@mui/icons-material";
import { getRootURL } from "../../helper/Utility";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import SearchIcon from "@mui/icons-material/Search";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import SettingsIcon from "@mui/icons-material/Settings";
import WorkIcon from "@mui/icons-material/Work";
import EmailIcon from "@mui/icons-material/Email";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import GroupIcon from "@mui/icons-material/Group";

const icons = {
  Dashboard,
  FolderSharedOutlined,
  PeopleAltOutlined,
  AddModeratorOutlined,
  PaidOutlined,
  NotificationsActiveOutlined,
  AccountCircleOutlined,
};

const dashboard = {
  id: "group-dashboard",
  type: "group",
  children: [
    {
      id: "dashboard",
      title: "Dashboard",
      type: "item",
      url: `/${getRootURL()}/dashboard`,
      icon: icons.Dashboard,
      breadcrumbs: false,
    },
    {
      id: "users",
      title: "Users",
      type: "collapse",
      icon: GroupIcon,
      children: [
        {
          id: "employer",
          title: "Employer",
          type: "item",
          url: `/${getRootURL()}/user/employer`,
          icon: PersonIcon,
          breadcrumbs: false,
        },
        {
          id: "employee",
          title: "Employee",
          type: "item",
          url: `/${getRootURL()}/user/employee`,
          icon: BusinessCenterIcon,
          breadcrumbs: false,
        },
        {
          id: "affiliate",
          title: "Affiliate",
          type: "item",
          url: `/${getRootURL()}/user/affiliate`,
          icon: BusinessCenterIcon,
          breadcrumbs: false,
        },
        {
          id: "agency",
          title: "Agency",
          type: "item",
          url: `/${getRootURL()}/user/agency`,
          icon: BusinessCenterIcon,
          breadcrumbs: false,
        },
        {
          id: "recruiter",
          title: "Recruiters",
          type: "item",
          url: `/${getRootURL()}/user/recruiter`,
          icon: BusinessCenterIcon,
          breadcrumbs: false,
        },
      ],
    },
    {
      id: "affiliate-commissions",
      title: "Affiliate Commissions",
      type: "item",
      url: `/${getRootURL()}/commissions/affiliate`,
      icon: BusinessCenterIcon,
      breadcrumbs: false,
    },
    {
      id: "agency-commissions",
      title: "Agency Commissions",
      type: "item",
      url: `/${getRootURL()}/commissions/agency`,
      icon: BusinessCenterIcon,
      breadcrumbs: false,
    },
    {
      id: "paid",
      title: "Paid History",
      type: "item",
      url: `/${getRootURL()}/commissions/paid`,
      icon: BusinessCenterIcon,
      breadcrumbs: false,
    },
    {
      id: "notification",
      title: "Notifications",
      type: "item",
      url: `/${getRootURL()}/notifications`,
      icon: NotificationsActiveIcon,
      breadcrumbs: false,
    },
    {
      id: "transactions",
      title: "Transactions",
      type: "item",
      url: `/${getRootURL()}/transactions`,
      icon: CurrencyExchangeIcon,
      breadcrumbs: false,
    },
    {
      id: "employerAllJob",
      title: "Posted Jobs",
      type: "item",
      url: `/${getRootURL()}/employerAllJob`,
      icon: WorkIcon,
      breadcrumbs: false,
    },
    {
      id: "shootJobMail",
      title: "Shoot Job Mail",
      type: "item",
      url: `/${getRootURL()}/shootJobMail`,
      icon: EmailIcon,
      breadcrumbs: false,
    },
    {
      id: "agreement",
      title: "Initial Agreement",
      type: "item",
      url: `/${getRootURL()}/agreement`,
      icon: FilePresentIcon,
      breadcrumbs: false,
    },
    {
      id: "final-agreement",
      title: "Final Agreement",
      type: "item",
      url: `/${getRootURL()}/final-agreement`,
      icon: FilePresentIcon,
      breadcrumbs: false,
    },
    {
      id: "subscriptions",
      title: "Membership",
      type: "item",
      url: `/${getRootURL()}/subscriptions`,
      icon: SubscriptionsIcon,
      breadcrumbs: false,
    },
    {
      id: "usersubscriptions",
      title: "User Membership",
      type: "item",
      url: `/${getRootURL()}/user-subscriptions`,
      icon: SubscriptionsIcon,
      breadcrumbs: false,
    },
    {
      id: 'contact-query',
      title: 'Contact Query',
      type: 'item',
      url: `/${getRootURL()}/contact-query`,
      icon: ContactPhoneIcon,
      breadcrumbs: false
    },
    {
      id: "ai-prompts",
      title: "AI Prompts",
      type: "item",
      url: `/${getRootURL()}/prompts`,
      icon: SearchIcon,
      breadcrumbs: false,
    },
    {
      id: "ai-questions",
      title: "AI Questions",
      type: "item",
      url: `/${getRootURL()}/questions`,
      icon: QuestionAnswerIcon,
      breadcrumbs: false,
    },
    {
      id: "settings",
      title: "Settings",
      type: "collapse",
      icon: SettingsSuggestIcon,
      children: [
        {
          id: "general-settings",
          title: "General Settings",
          type: "item",
          url: `/${getRootURL()}/general-settings`,
          icon: SettingsIcon,
          breadcrumbs: false,
        },
        {
          id: "home-page",
          title: "Home Page",
          type: "item",
          url: `/${getRootURL()}/home-page`,
          icon: HomeIcon,
          breadcrumbs: false,
        },
        {
          id: "static-pages",
          title: "Pages",
          type: "item",
          url: `/${getRootURL()}/static-pages`,
          icon: AddBusinessIcon,
          breadcrumbs: false,
        },
        {
          id: "blog",
          title: "Blog",
          type: "item",
          url: `/${getRootURL()}/blog`,
          icon: AddBusinessIcon,
          breadcrumbs: false,
        },
        {
          id: "seo",
          title: "SEO",
          type: "item",
          url: `/${getRootURL()}/seo`,
          icon: SearchIcon,
          breadcrumbs: false,
        },
      ],
    },
  ],
};

export default dashboard;